// extracted by mini-css-extract-plugin
module.exports = {"filterItem":"filterItem_filterItem_198AqGF","label":"filterItem_label_26N8IUB"};